import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { API } from '../config';
import '../styles/theme.css';

function PaymentSuccess() {
  const navigate = useNavigate();
  const userType = localStorage.getItem('user_type');
  const [tier, setTier] = useState(null);
  const [checking, setChecking] = useState(true);
  const [attempts, setAttempts] = useState(0);
  const pollRef = useRef(null);

  const doRefresh = async () => {
    const token = localStorage.getItem('token');
    if (!token) return null;
    try {
      // First try manual sync (verifies with Paystack directly)
      const syncRes = await fetch(`${API}/payments/sync-tier/`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (syncRes.ok) {
        const data = await syncRes.json();
        localStorage.setItem('user_tier', data.tier);
        setTier(data.tier);
        return data.tier;
      }
      // Fallback to simple tier check
      const res = await fetch(`${API}/payments/my-tier/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem('user_tier', data.tier);
        setTier(data.tier);
        return data.tier;
      }
    } catch {}
    return null;
  };

  useEffect(() => {
    let count = 0;

    pollRef.current = setInterval(async () => {
      count++;
      setAttempts(count);
      const t = await doRefresh();
      const isPaid = t && t !== 'free' && t !== 'starter';

      if (isPaid || count >= 12) {
        clearInterval(pollRef.current);
        setChecking(false);
        if (isPaid) {
          localStorage.setItem('show_welcome_modal', 'true');
          setTimeout(() => {
            navigate(userType === 'RECRUITER' ? '/recruiter/dashboard' : '/dashboard');
          }, 2500);
        }
      }
    }, 2000);

    return () => clearInterval(pollRef.current);
  }, []);

  const handleManualRefresh = async () => {
    setChecking(true);
    const t = await doRefresh();
    setChecking(false);
    const isPaid = t && t !== 'free' && t !== 'starter';
    if (isPaid) {
      localStorage.setItem('show_welcome_modal', 'true');
      navigate(userType === 'RECRUITER' ? '/recruiter/dashboard' : '/dashboard');
    }
  };

  const tierLabel = tier ? tier.charAt(0).toUpperCase() + tier.slice(1) : '';
  const isPaid = tier && tier !== 'free' && tier !== 'starter';

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)', flexDirection: 'column', gap: '1rem', textAlign: 'center', padding: '2rem'
    }}>
      <div style={{
        width: 72, height: 72, borderRadius: '50%', background: 'rgba(34,197,94,0.15)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '2rem', color: 'var(--success)'
      }}>
        <i className="fas fa-check-circle"></i>
      </div>

      <h1 style={{ color: 'var(--text-primary)', margin: 0 }}>Payment Successful!</h1>

      {isPaid ? (
        <p style={{ color: 'var(--primary)', fontWeight: 600, margin: 0 }}>
          {tierLabel} plan activated ✓
        </p>
      ) : checking ? (
        <p style={{ color: 'var(--text-muted)', margin: 0, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <i className="fas fa-spinner fa-spin"></i>
          Confirming your plan... ({attempts}/12)
        </p>
      ) : (
        <p style={{ color: 'var(--warning)', margin: 0 }}>
          <i className="fas fa-exclamation-triangle"></i> Plan update is taking longer than expected.
        </p>
      )}

      <p style={{ color: 'var(--text-muted)', maxWidth: 420, margin: 0, fontSize: '0.9rem' }}>
        {isPaid
          ? 'Your subscription is now active. Redirecting you to your dashboard...'
          : 'We\'re waiting for payment confirmation. This usually takes a few seconds.'}
      </p>

      <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap', justifyContent: 'center' }}>
        <button
          className="btn btn-primary"
          onClick={() => navigate(userType === 'RECRUITER' ? '/recruiter/dashboard' : '/dashboard')}
        >
          Go to Dashboard
        </button>
        {!isPaid && !checking && (
          <button className="btn btn-secondary" onClick={handleManualRefresh}>
            <i className="fas fa-sync-alt"></i> Refresh Plan
          </button>
        )}
      </div>

      {!isPaid && !checking && (
        <p style={{ color: 'var(--text-muted)', fontSize: '0.8rem', maxWidth: 400, margin: 0 }}>
          If your plan hasn't updated after a minute, click "Refresh Plan" or contact support at{' '}
          <a href="mailto:support@joblinkedai.co.za" style={{ color: 'var(--primary)' }}>support@joblinkedai.co.za</a>
        </p>
      )}
    </div>
  );
}

export default PaymentSuccess;
